import {
  ButtonType,
  CaesarsButton,
  OpenUrlTarget,
  PanelContainer,
  SVG,
  openURL,
  useIsDesktop,
  useIsLargeDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import ncpg from 'assets/NCPG.svg';
import {Link, Text, View} from 'native-base';
import React from 'react';
import {useTheme} from 'styled-components/native';

const ResponsibleGamingModule: React.FC = () => {
  const isDesktop = useIsDesktop();
  const isLargeDesktop = useIsLargeDesktop();
  const theme = useTheme();

  const {ghostWhite} = theme.colors;

  return (
    <PanelContainer
      defaultOpen={false}
      icon="dice"
      panelTitle={
        isDesktop
          ? "CAESARS' RESPONSIBLE GAMING STANDARDS"
          : 'RESPONSIBLE GAMING'
      }
      primaryCTA={{
        label: 'Learn More',
        onPress: () =>
          openURL(
            'https://www.caesars.com/corporate/corporate-social-responsibility/play/responsible-gaming',
            OpenUrlTarget.BLANK
          ),
      }}>
      <View
        flexDirection={isLargeDesktop ? 'row' : 'column'}
        alignItems={isLargeDesktop || !isDesktop ? 'flex-end' : 'center'}
        // width={isLargeDesktop ? '125%' : '100%'}
      >
        <Text
          fontFamily="body"
          fontSize={isDesktop ? 4 : '14px'}
          lineHeight={isDesktop ? '26px' : '24px'}
          pr={isLargeDesktop ? '64px' : undefined}
          pb={isLargeDesktop ? undefined : 6}>
          Promoting responsible gaming is part of the heritage and culture of
          Caesars Entertainment. It&apos;s the foundation of our Code of
          Commitment, which spells out the principles that govern the way we do
          business. Our company&apos;s long-standing and continuing commitment
          to responsible gaming is something we take great pride in. Caesars
          Entertainment&apos;s position on this issue is clear: We want everyone
          who gambles at our casinos to be there for the right reasons - to
          simply have fun. We believe that all entities involved in legal
          wagering have an obligation to promote responsible gaming and address
          underage gambling.
        </Text>
        <View
          backgroundColor={ghostWhite}
          width={isLargeDesktop ? '250px' : '100%'}
          borderRadius="4px"
          alignItems="center">
          <View
            flex={1}
            px={isDesktop ? 6 : 5}
            py={6}
            width="250px"
            alignItems="center">
            <View alignItems="center" justifyContent="center" mb={4}>
              <Link
                href="https://www.ncpgambling.org/help-treatment/national-helpline-1-800-522-4700/"
                isExternal>
                <SVG source={ncpg} width={146} height={44} />
              </Link>
            </View>
            <View mb={5}>
              <Text
                color="#0065AD"
                fontFamily="heading"
                fontSize="14px"
                lineHeight="22px"
                textAlign="center"
                fontWeight="bold">
                National Problem Gambling Hotline
              </Text>
            </View>
            <View alignItems="center" width="180px">
              <CaesarsButton
                type={ButtonType.SECONDARY}
                isFullWidth={true}
                title="Contact NCPG"
                onPress={() => {
                  openURL(
                    'https://www.ncpgambling.org/help-treatment/national-helpline-1-800-522-4700/',
                    OpenUrlTarget.BLANK
                  );
                }}
              />
            </View>
          </View>
        </View>
      </View>
    </PanelContainer>
  );
};

export default ResponsibleGamingModule;
